<template>
  <div>
    <NotFoundData v-if="isEmptyData" />
    <div :style="{ visibility: isEmptyData ? 'collapse' : 'visible' }">
      <div class="contenedor-graficas-rg">
        <div class="contenedor-grafica gnc"></div>
        <div class="contenedor-grafica gtp"></div>
        <div class="contenedor-grafica gmo"></div>
      </div>
      <hr>
      <p class="text-dark w-100">
        Personaliza los filtros para cada gráfica, seleccionando las etiquetas de forma individual.
      </p>
    </div>
  </div>
</template>
<script>
import axios from "axios";
import * as echarts from "echarts";
import servicios from "../../../servicios/service.js";
import NotFoundData from "@/Aplicaciones/Masters/Areas/Prospecto/components/Graficas/NotFoundData.vue"
const reporteGeneral = "/api/Dashboard/Dashboard/GraficaReporteGeneral";

const labelFormatNumeroClientes = {
  formatter: "{c}",
  position: "inside",
  fontSize: 14,
  fontWeight: "bold",
  color: "#ffffff"
};

const labelFormatMontoOperaciones = {
  show: true,
  position: "top",
  align: "left",
  formatter: function (valor) {
    return servicios.DarFormatoMoneda(valor.value);
  },
  fontSize: 14,
  fontWeight: "bold",
  color: "#000000"
};
export default {
  name: "GraficaReporteGeneral",
  components: {
    NotFoundData
  },
  props: [
    "masterId",
    "embajadorId",
    "sucursalId",
    "gerenciaId",
    "fechaInicio",
    "fechaFinal",
    "mostrarTodo"
  ],
  data() {
    return {
      dataNumeroClientes: [],
      dataTipoClientes: [],
      dataOperacionGrafica: [],
    }
  },
  mounted() {
    this.numeroClientesGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.mostrarTodo
    );
    this.tipoClienteContratadoGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.mostrarTodo
    );
    this.montoOperacionGrafica(
      this.masterId,
      this.embajadorId,
      this.sucursalId,
      this.gerenciaId,
      this.fechaInicio,
      this.fechaFinal,
      this.mostrarTodo
    );
  },
  watch: {
    mostrarTodo() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaFinal() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    fechaInicio() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    gerenciaId() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    sucursalId() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    },
    embajadorId() {
      this.numeroClientesGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.tipoClienteContratadoGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
      this.montoOperacionGrafica(
        this.masterId,
        this.embajadorId,
        this.sucursalId,
        this.gerenciaId,
        this.fechaInicio,
        this.fechaFinal,
        this.mostrarTodo
      );
    }
  },
  methods: {
    async numeroClientesGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          mostrarTodo
        }
      };
      // Definir el orden deseado de las etapas
      var ordenDeseado = ["Contratado", "Prospecto", "Pausado"];
      try {
        let resp = await axios.get(reporteGeneral, params);

        let miGraficaNumeroClientes = echarts.dispose(
          document.querySelector(".contenedor-grafica.gnc")
        );
        miGraficaNumeroClientes = echarts.init(
          document.querySelector(".contenedor-grafica.gnc")
        );
        let options = {
          color: [],
          textStyle: {
            fontFamily: "Poppins"
          },
          legend: {
            show: true,
            top: "bottom",
            orient: "horizontal",
            left: "center",
            icon: "circle",
            textStyle: {
              color: "black"
            }
          },
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          tooltip: {
            trigger: "item"
          },
          series: [
            {
              type: "pie",
              stillShowZeroSum: false,
              data: []
            }
          ]
        };
        const clientesPorEtapaData = resp.data.data.clientesPorEtapaDashboard.sort(function (a, b) {
          return ordenDeseado.indexOf(a.etapa) - ordenDeseado.indexOf(b.etapa);
        });
        this.dataNumeroClientes = resp.data.data.clientesPorEtapaDashboard;
        let validarExistenciaDatos = 0;
        let titulo = null;
        clientesPorEtapaData.map((element, index) => {
          options.series[0].data.push({
            value: element.valor,
            name: element.etapa,
            label: labelFormatNumeroClientes
          });
          options.series[0].data[index].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
          if (options.series[0].data[index].name === "Contratado") {
            options.color.push("#BA704F");
          }
          if (options.series[0].data[index].name === "Pausado") {
            options.color.push("#9DC08B");
          }
          if (options.series[0].data[index].name === "Prospecto") {
            options.color.push("#344D67");
          }
        });
        if (validarExistenciaDatos > 0) {
          titulo = "Número de clientes";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaNumeroClientes.setOption(options);
      } catch (error) {
        console.log(error);
      }
    },
    async tipoClienteContratadoGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          mostrarTodo
        }
      };
      try {
        const resp = await axios.get(reporteGeneral, params);
        let miGraficaTipoClienteCintratado = echarts.dispose(
          document.querySelector(".contenedor-grafica.gtp")
        );
        miGraficaTipoClienteCintratado = echarts.init(
          document.querySelector(".contenedor-grafica.gtp")
        );
        const clientesPorTipoData = resp.data.data.clientesPorTipoDashboard;
        this.dataTipoClientes = resp.data.data.clientesPorTipoDashboard;
        let titulo = null;
        let options = {
          color: ["#4B778D", "#C8AE7D"],
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          textStyle: {
            fontFamily: "Poppins"
          },
          tooltip: {
            trigger: "axis",
            axisPointer: {
              type: 'shadow'
            }
          },
          legend: {
            show: true,
            top: "bottom",
            orient: "horizontal",
            left: "center",
            icon: "circle",
            textStyle: {
              color: "black"
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            show: false
          },
          yAxis: {
            type: "category",
            data: [],
            axisLabel: {
              color: "black", // Cambia el color del texto a negro
            },
          },
          series: [
            {
              name: "Monto",
              type: "bar",

              label: {
                show: true,
                position: "top",
                fontWeight: 'bold',
                formatter: function (valor) {
                  return servicios.DarFormatoMoneda(valor.value);
                },
              },
              emphasis: {
                focus: "series"
              },
              barMinHeight: "50",
              barMaxHeight: "100", // Establece la altura máxima de la barra en 50 unidades

              stillShowZeroSum: false,
              data: []
            },
            {
              name: "Número de clientes",
              type: "bar",

              label: {
                show: true,
                fontSize: 10,
                fontWeight: "bold",
                color: "#000",
                position: "inside"
              },
              emphasis: {
                focus: "series"
              },
              barMinHeight: "50",
              barMaxHeight: "100", // Establece la altura máxima de la barra en 50 unidades

              stillShowZeroSum: false,
              data: []
            }
          ]
        };

        clientesPorTipoData.map((element) => {
          options.yAxis.data.push(element.tipoPersona);
          options.series[1].data.push({
            value: element.valor,
            name: "Número de clientes ",
          });
          options.series[0].data.push({
            value: element.monto,
            name: "Monto",
          });
        });

        if (this.dataTipoClientes.length > 0) {
          titulo = "Tipos de Clientes Contratados";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaTipoClienteCintratado.setOption(options);
      } catch (error) {
        console.log(error);
      }
    },
    async montoOperacionGrafica(
      masterId,
      embajadorId,
      sucursalId,
      gerenciaId,
      fechaInicio,
      fechaFinal,
      mostrarTodo
    ) {
      const params = {
        params: {
          masterId,
          embajadorId,
          sucursalId,
          gerenciaId,
          fechaInicio,
          fechaFinal,
          mostrarTodo
        }
      };

      // Definir el orden deseado de las etapas
      var ordenDeseado = ["Contratado", "Prospecto", "Pausado"];
      try {
        const resp = await axios.get(reporteGeneral, params);
        let miGraficaMontoOperacion = echarts.dispose(
          document.querySelector(".contenedor-grafica.gmo")
        );
        miGraficaMontoOperacion = echarts.init(
          document.querySelector(".contenedor-grafica.gmo")
        );
        const clientesPorTipoMontoData =
          resp.data.data.clientesPorEtapaDashboard.sort(function (a, b) {
            return ordenDeseado.indexOf(a.etapa) - ordenDeseado.indexOf(b.etapa);
          });
        this.dataOperacionGrafica = resp.data.data.clientesPorEtapaDashboard;

        let options = {
          color: [],
          textStyle: {
            fontFamily: "Poppins"
          },
          title: {
            text: "",
            left: "center",
            textStyle: {
              color: "black"
            }
          },
          tooltip: {
            trigger: "item",
            axisPointer: {
              type: "shadow"
            }
          },
          legend: {
            show: true,
            top: "bottom",
            orient: "horizontal",
            left: "center",
            icon: "circle",
            textStyle: {
              color: "black"
            }
          },
          grid: {
            left: "3%",
            right: "4%",
            bottom: "3%",
            containLabel: true
          },
          xAxis: {
            type: "value",
            boundaryGap: [0, 0.01],
            show: false
          },
          yAxis: {
            type: "category",
            show: false
          },
          series: []
        };
        let validarExistenciaDatos = 0;
        let titulo = null;
        clientesPorTipoMontoData.map((element, index) => {
          options.series.push({
            name: element.etapa,
            type: "bar",
            barGap: "1",
            stillShowZeroSum: false,
            data: [
              {
                value: element.monto,
                name: "Monto",
                label: labelFormatMontoOperaciones
              }
            ]
          });
          options.series[index].data[0].value > 0
            ? validarExistenciaDatos++
            : validarExistenciaDatos;
          if (options.series[index].name === "Contratado") {
            options.color.push("#BA704F");
          }
          if (options.series[index].name === "Pausado") {
            options.color.push("#9DC08B");
          }
          if (options.series[index].name === "Prospecto") {
            options.color.push("#344D67");
          }
        });
        if (validarExistenciaDatos > 0) {
          titulo = "Monto de las Operaciones";
          options.legend.show = true;
        } else {
          titulo = "NO HAY DATOS";
          options.legend.show = false;
        }
        options.title.text = titulo;
        miGraficaMontoOperacion.setOption(options);
      } catch (error) {
        console.log(error);
      }
    }
  },
  computed: {
    isEmptyData() {
      return (
        this.dataNumeroClientes.length === 0 &&
        this.dataTipoClientes.length === 0 &&
        this.dataOperacionGrafica.length === 0
      );
    }
  }
};
</script>
<style scoped>
.contenedor-graficas-rg {
  display: grid;
  gap: 2%;
  grid-template-columns: 49% 49%;
  grid-template-rows: 300px 300px;
  margin: 20px 0 30px;
}

.contenedor-grafica {
  border: 2px solid #cbcbcb;
  padding: 20px;
}

.gnc {
  grid-row: 1 / 3;
}
</style>
